import Vue from 'vue'
import Vcalendar from 'v-calendar'

Vue.use(Vcalendar, {
  datePickerTintColor: '#F00',
  datePickerShowDayPopover: false,
})
